<template>
  <BaseLayout :title="title">
    <template #actions>
      <InlineButton @click="onCreate" pill shadow>
        <span class="text-uppercase">{{ $t('text.newButton') }}</span>
      </InlineButton>
    </template>

    <StaffTable
      :list="staffList"
      :current-page="currentPage"
      :meta="staffListMeta"
      :is-loading="isLoading"
      :type-list="userTypeList"
      @edit="onEdit"
      @onChangePage="onChangePage"
    />

    <StaffAddEditModal
      :form-data="dataToEdit"
      :modal-id="editModalId"
      :type-list="userTypeList"
      @onHidden="onHidden"
      @onRemove="onConfirmDelete"
    />

    <ConfirmDialog :id="deleteModalId" @ok="remove" />
  </BaseLayout>
</template>

<script>
import { mapGetters } from 'vuex';
import { STAFF_LIST_REQUEST, STAFF_DELETE } from '@/store/actions/staff';
import { STAFF_TYPES } from '@/utils/constants';
import BaseLayout from '@/components/ui/BaseLayout';
import InlineButton from '@/components/ui/button/InlineButton';
import StaffTable from '@/components/manage/staff/StaffTable';
import StaffAddEditModal from '@/components/manage/staff/StaffAddEditModal';
import ConfirmDialog from '@/components/ui/ConfirmDialog';

export default {
  props: {
    title: String,
  },

  data() {
    return {
      currentPage: 1,
      dataIdToEdit: null,
      dataIdToRemove: null,
      editModalId: 'manage-form-modal',
      deleteModalId: 'manage-delete-modal',
      userTypeList: STAFF_TYPES,
    };
  },

  computed: {
    ...mapGetters(['staffStatus', 'staffList', 'staffListMeta', 'staffListStatus', 'getStaffById']),
    dataToEdit() {
      return this.dataIdToEdit ? this.getStaffById(this.dataIdToEdit) : null;
    },
    isLoading() {
      return this.staffListStatus === 'loading';
    },
  },

  created() {
    this.fetchData();
  },

  methods: {
    async fetchData() {
      const payload = {
        limit: 150,
        page: this.currentPage,
        filter: {},
      };
      await this.$store.dispatch(STAFF_LIST_REQUEST, payload);
    },
    emptyingDataToEdit() {
      this.dataIdToEdit = null;
    },
    onCreate() {
      this.emptyingDataToEdit();
      this.openModal();
    },
    onEdit(id) {
      this.dataIdToEdit = id;
      this.openModal();
    },
    openModal() {
      this.$bvModal.show(this.editModalId);
    },
    onChangePage(page) {
      this.currentPage = page;
      this.fetchData();
    },
    onConfirmDelete(id) {
      this.dataIdToRemove = id;
      this.$bvModal.show(this.deleteModalId);
    },
    async remove() {
      await this.$store.dispatch(STAFF_DELETE, this.dataIdToRemove);
      if (this.staffStatus === 'deleted') {
        this.$bvModal.hide(this.editModalId);
        this.dataIdToRemove = null;
      }
    },
    onHidden() {
      this.emptyingDataToEdit();
      this.fetchData();
    },
  },

  components: {
    BaseLayout,
    InlineButton,
    StaffTable,
    StaffAddEditModal,
    ConfirmDialog,
  },
};
</script>
